// custom javascript
(function(){
// mobile subnav expand on load
//   $(".nav-hamburger .has-submenu").addClass("is-expanded");
  
  
// blog filter   
  var $filterBy = $('#BlogTagFilter');
  if (!$filterBy.length) {
    return;
  }
  $filterBy.on('change', function() {
    location.href = $(this).val();
  });
  
// upsell addon app
  $('.upsell-addonbox button.upsell-addToCart').setAttribute("data-ajax", "true");
  
  
})();